import Vue from 'vue'
import Router from 'vue-router'
import addUserRole from '@/components/admin/user/addUserRole'
import userDetail from '@/components/admin/user/userDetail'
import userManagement from '@/components/admin/user/userManagement'
import index from '@/components/mobile/index'
import sensorHistory from '@/components/mobile/sensorHistory'
import commonDevice from '@/components/mobile/commonDevice'
import warningList from '@/components/mobile/warningList'
import map from '@/components/mobile/map'
import video from '@/components/mobile/video'
import groupDetail from '@/components/mobile/groupDetail'
import controllerHistory from '@/components/mobile/controllerHistory'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/admin/user/login')
    },
    {
      path: '/lsfjb',
      name: 'lsfjb-login',
      component: () => import('@/components/admin/user/lsfjb-login')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/components/home'),
    },
    {
        path: '/',
        redirect: "/admin",
    },
    {
      path: '/InternetThings',
      name: 'InternetThings',
      meta: {allowBack: false},
      component: () => import('@/components/InternetThings'),
    },
		{
		  path: '/internetThingsFjb',
		  name: 'internetThingsFjb',
		  meta: {allowBack: false},
		  component: () => import('@/components/internetThingsFjb'),
		},
    {
      path: '/sewageSludgeMachine',
      name: 'sewageSludgeMachine',
      meta: {allowBack: false},
      component: () => import('@/components/sewageSludgeMachine'),
    },
    {
      path: '/main',
      name: 'main',
      component: () => import('@/components/main'),
      redirect: "/admin",
      children: [
        {
          path: '/admin',
          name: 'admin',
          component: () => import('@/components/admin/admin'),
          redirect: "/deviceSensorManagement",
        },
        {
          path: '/deviceSensorManagement',
          name: 'deviceSensorManagement',
          component: () => import('@/components/admin/deviceSensor')
        },
        {
          path: '/deviceCameraManagement',
          name: 'deviceCameraManagement',
          component: () => import('@/components/admin/deviceCamera')
        },
        {
          path: '/deviceControllerManagement',
          name: 'deviceControllerManagement',
          component: () => import('@/components/admin/deviceController')
        },
        {
          path: '/shuifei',
          name: 'shuifei',
          component: () => import('@/components/admin/shuifei')
        },
        {
          path: '/shuifeiDetail',
          name: 'shuifeiDetail',
          component: () => import('@/components/admin/shuifeiDetail')
        },
        {
          path: '/deviceGroupManagement',
          name: 'deviceGroupManagement',
          component: () => import('@/components/admin/deviceGroup')
        },
        {
          path: '/deviceGroupEdit',
          name: 'deviceGroupEdit',
          component: () => import('@/components/admin/deviceGroupEdit')
        },
        {
          path: '/addUserRole',
          name: 'addUserRole',
          component: () => import('@/components/admin/user/addUserRole')
        },
        {
          path: '/userDetail',
          name: 'userDetail',
          component: () => import('@/components/admin/user/userDetail')
        },
        {
          path: '/userManagement',
          name: 'userManagement',
          component: () => import('@/components/admin/user/userManagement')
        },
        {
          path: '/roleManagement',
          name: 'roleManagement',
          component: () => import('@/components/admin/user/roleManagement')
        },
        {
          path: '/roleDetail',
          name: 'roleDetail',
          component: () => import('@/components/admin/user/roleDetail')
        },
        {
          path: '/companyManagement',
          name: 'companyManagement',
          component: () => import('@/components/admin/companyManagement')
        },
        {
          path: '/companyDetail',
          name: 'companyDetail',
          component: () => import('@/components/admin/companyDetail')
        },
        {
          path: '/personalInformation',
          name: 'personalInformation',
          component: () => import('@/components/admin/user/personalInformation')
        }
      ]
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: () => import('@/components/main'),
      redirect: "/m/index",
      children: [
        //手机端
        {
          path: '/m/index',
          name: 'index',
          component: () => import('@/components/mobile/index')
        },
        {
          path: '/m/sensorHistory',
          name: 'sensorHistory',
          component: () => import('@/components/mobile/sensorHistory')
        },
        {
          path: '/m/commonDevice',
          name: 'commonDevice',
          component: () => import('@/components/mobile/commonDevice')
        },
        {
          path: '/m/warningList',
          name: 'warningList',
          component: () => import('@/components/mobile/warningList')
        },
        {
          path: '/m/map',
          name: 'map',
          component: () => import('@/components/mobile/map')
        },
        {
          path: '/m/video',
          name: 'video',
          component: () => import('@/components/mobile/video')
        },
        {
          path: '/m/groupDetail',
          name: 'groupDetail',
          component: () => import('@/components/mobile/groupDetail')
        },
        {
          path: '/m/mpGroupDetail',
          name: 'mpGroupDetail',
          component: () => import('@/components/mobile/mpGroupDetail')
        },
        {
          path: '/m/controllerHistory',
          name: 'controllerHistory',
          component: () => import('@/components/mobile/controllerHistory')
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js